import { render, staticRenderFns } from "./category_copy_5.vue?vue&type=template&id=434cb733&scoped=true&"
import script from "./category_copy_5.vue?vue&type=script&lang=js&"
export * from "./category_copy_5.vue?vue&type=script&lang=js&"
import style0 from "./category_copy_5.vue?vue&type=style&index=0&id=434cb733&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434cb733",
  null
  
)

export default component.exports